import React from 'react';

export default {
  logoBuilder: 'Criador de logos',
  beta: 'Beta',
  title: (
    <>
      Crie
      {' '}
      <strong>designs profissionais de forma simples</strong>
      {' '}
      com nossa ferramenta de criação.
    </>
  ),
  description: 'Com o HostGator Creator, você pode criar logos, conteúdo e designs com aparência profissional para a sua marca e aumentar a credibilidade com os seus clientes.',
  choosePlan: 'Escolha o plano ideal para o seu negócio',
  freePlan: 'Criador de Logo',
  free: 'Grátis',
  freePlanDescription: 'Crie seu logo grátis agora',
  continueWithFree: 'Continuar no plano grátis',
  freeSpecs: ['Crie até 1 logo', 'Logo personalizado para o seu negócio'],
  paidPlan: 'HostGator Creator',
  paidPlanPrice: (
    <>
      <strong>R$ 19,90</strong>
      {' '}
      por mês.
    </>
  ),
  yearlyPrice: 'R$ 239,88 / ano',
  paidPlanDescription: (
    <>
      Crie logos e designs
      <br />
      profissionais para o seu negócio.
    </>
  ),
  startNow: 'Começar agora',
  paidSpecs: ['Criador de logo com IA', 'Criação ilimitada', 'Editor fácil de arrastar e soltar', 'Removedor de fundo', 'Criação de conteúdo para redes sociais, vídeos, etc...', 'Kit de marca', 'Templates profissionais', 'Paleta de cores da sua marca', 'Milhares de imagens gratuitas'],
  modalLogoGeneration: {
    thankYouForInterest: (
      <>
        Obrigado pelo interesse no plano
        {' '}
        <strong>HostGator Creator!</strong>
      </>
    ),
    itIsATest: (
      <>
        Estamos testando o interesse dos nossos clientes por essa novidade,
        {' '}
        <strong>você não será cobrado por nada!</strong>
        {' '}
        Enquanto isso, continue aproveitando o
        {' '}
        <strong>plano gratuito</strong>
        {' '}
        para criar seu logotipo profissional. Fique tranquilo, avisaremos assim que a nova ferramenta estiver no ar!
      </>
    ),
    tellUsAboutYourBrand: 'Nos conte um pouco sobre a sua marca',
    brandName: 'Nome da marca',
    brandSlogan: 'Slogan',
    category: 'Selecione qual categoria da sua empresa',
    categories: [
      'Alimentação e Bebidas',
      'Arquitetura',
      'Calçados',
      'Clínicas e Consultórios',
      'Construção e Imobiliário',
      'Contabilidade',
      'Cursos Online',
      'Decoração e Design de Interiores',
      'Desenvolvimento de Software',
      'Docerias e Padarias',
      'Ecoturismo',
      'Educação e Treinamento',
      'Eletrônicos',
      'Engenharia Civil',
      'Entrega de Comida',
      'Entretenimento e Artes',
      'Escolas e Universidades',
      'Escritórios de Advocacia',
      'Estética e Beleza',
      'Estúdios de Fotografia',
      'Eventos e Shows',
      'Finanças e Jurídico',
      'Fintechs',
      'Fitness',
      'Grupos Musicais',
      'Hotéis e Pousadas',
      'Idiomas',
      'Imobiliárias',
      'Inteligência Artificial',
      'Investimentos',
      'Jogos e Aplicativos',
      'Joias e Relógios',
      'Locadoras de Veículos',
      'Lojas de Roupas',
      'Marcas de Luxo',
      'Marketing e Comunicação',
      'Moda e Vestuário',
      'Moda Sustentável',
      'Motoboy (Serviços de)',
      'Padarias',
      'Paisagismo',
      'Pet Shop',
      'Produção de Vídeos',
      'Produtos Naturais',
      'Relações Públicas',
      'Resorts',
      'Restaurantes e Cafeterias',
      'Roupas e Acessórios',
      'Saúde e Bem-estar',
      'Saúde Mental',
      'Supermercados',
      'Tecnologia e Inovação',
      'Transporte',
      'Treinamentos Corporativos',
      'Turismo e Hotelaria',
      'Varejo e Comércio',
    ],
    selectColor: 'Selecione a cor que melhor represente a sua marca',
    colors: [
      {
        name: 'Tons de cinza',
        description: 'Clássico, elegante, moderno',
        background: 'linear-gradient(85deg, #2D2D2D 39.87%, #4F4848 67.95%, #939393 96.03%)',
      },
      {
        name: 'Azul',
        description: 'Calmo, harmonioso, confiante',
        background: 'linear-gradient(265deg, #4790E1 3.97%, #2779D4 32.05%, #0F68CB 60.13%)',
      },
      {
        name: 'Vermelho',
        description: 'Corajoso, energético, vibrante',
        background: 'linear-gradient(265deg, #D53940 1.91%, #C8171E 30.61%, #BE0007 59.32%)',
      },
      {
        name: 'Verde',
        description: 'Natural, refrescante, crescimento',
        background: 'linear-gradient(265deg, #57D057 3.97%, #25AD25 32.05%, #009401 60.13%)',
      },
      {
        name: 'Amarelo',
        description: 'Otimista, feliz, brilhante',
        background: 'linear-gradient(244deg, #E5B100 35.73%, #F3C523 63.7%, #FFD540 91.67%)',
      },
      {
        name: 'Laranja',
        description: 'Calmo, harmonioso, confiante',
        background: 'linear-gradient(265deg, #FE884C 0.73%, #F56017 29.79%, #F15000 58.86%)',
      },
      {
        name: 'Rosa',
        description: 'Calmo, harmonioso, confiante',
        background: 'linear-gradient(265deg, #D20CAE 39.87%, #DA30BC 67.95%, #E765D0 96.03%)',
      },
      {
        name: 'Roxa',
        description: 'Calmo, harmonioso, confiante',
        background: 'linear-gradient(265deg, #A764D0 3.97%, #8F22D1 32.05%, #8300D2 60.13%)',
      },
    ],
    back: 'Voltar',
    create: 'Criar logo',
    errorMessage: 'Selecione uma cor e preencha os itens obrigatórios antes de continuar',
    helpTextSlogan: 'Uma frase que define sua marca.',
    generatingLogo: 'Estamos solicitando o seu logo profissional, um momento...',
  },
  modalPaidPlan: {
    modalPaidPlanTitle: (
      <>
        Você está adquirindo o plano
        {' '}
        <strong>HostGator Creator</strong>
      </>
    ),
    stepItemTitleFreeTrial: (
      <>
        Teste gratuito de 30 dias.
        {' '}
        <strong>Cancele quando quiser</strong>
      </>
    ),
    stepItemSubtitleFreeTrial: 'Comece o seu teste gratuíto com o HostGator Studio e aproveite nossos recursos',
    stepItemSubtitleReminder: 'Vamos te enviar um lembrete para você 7 dias antes do final do seu período de teste',
    stepItemSubtitleCharge: 'Caso você não tenha cancelado sua assinatura durante o periodo de teste, ela será ativada.',
    boxSummaryTitle: 'Resumo',
    buttonContinue: 'Continuar para pagamento',
  },
  infosLogoBuilderSuccessModal: {
    title: (
      <>
        {' '}
        Sua logo será
        {' '}
        <strong>enviada no seu e-mail!</strong>
      </>
    ),
    message: 'Você fez parte do nosso teste de interesse do Criador de Logos e sua participação foi essencial! Vamos te enviar sua logo em breve, fique atento a sua caixa de e-mail.',
    buttonLabel: 'Ok, entendi',
  },
};
